import { fiscalPaymentsConstants } from "../../../actions/precog/fiscalPayments";

const defaultState = {
  status: {
    started: false,
    saving: false,
    error: false,
    ended: false
  },
  savedList: []
};

export function fiscalPayments(state = defaultState, { type, payload, error }) {
  switch (type) {
  case fiscalPaymentsConstants.CLEAR_PRECOG_FISCAL_PAYMENTS:
    return defaultState;
  case fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_START:
    return {
      ...state,
      status: {
        started: true,
        saving: false,
        error: false,
        ended: false
      }
    };
  case fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_START:
  case fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_START:
    return {
      ...state,
      status: {
        started: false,
        saving: true,
        error: false,
        ended: false
      }
    };
  case fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        saving: false,
        error: false,
        ended: true
      },
      savedList: payload
    };
  case fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_SUCCESS:
  case fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        saving: false,
        error: false,
        ended: true
      }
    };
  case fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_ERROR:
  case fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_ERROR:
  case fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_ERROR:
    return {
      ...state,
      status: {
        started: false,
        saving: false,
        error: true,
        ended: true
      }
    };
  default:
    return state;
  }
}
